// ============================================================
// DodgeSuccessChart - Dodge DoS distribution bar chart, in blue.
// ============================================================
import type { ReactionProbability } from '../../engine/defenceProbability';
import ReactionDosChart from './ReactionDosChart';

export default function DodgeSuccessChart({ data }: { data: ReactionProbability }) {
  return <ReactionDosChart data={data} colour="#60a5fa" />;
}
